<template>
  <div>
    <a class="waves-effect waves-light btn green" @click="compartilharWhats()">
      <i class="fab fa-whatsapp"></i> WhatsApp
    </a>
    <div class="altura"></div>
    <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + this.generateUrl()"
       target="_blank" class="waves-effect waves-light btn blue">
      <i class="fab fa-facebook"></i> Facebook
    </a>
    <!-- <div class="altura"></div>
    <a :href="'https://www.instagram.com/?url=' +  this.$store.state.app_url + this.$store.state.empresa.usuario_url"
       target="_blank"
       rel="noopener"
       class="waves-effect waves-light btn blue btn-insta">
      <i class="fab fa-instagram"></i> Instagram
    </a> -->
    <div class="altura"></div>
    <a class="waves-effect waves-light btn light-blue"
      :href="'https://twitter.com/intent/tweet?url=' + this.generateUrl() +'&text=Faça seu pedido online!'" target="_blank" >
        <i class="fab fa-twitter"></i> Twitter
    </a>
  </div>
</template>

<script>
import { WMCompose, WMSend } from "@aninga/whatsapp-manager";

export default {
  name: "ShareComponent",
  data(){
    return{

    }
  },
  methods: {
    compartilharWhats() {
      let share = new WMCompose();
      share.writeText("*" + this.$store.state.empresa.nome + "*");
      share.writeText("Faça seu pedido online!", 1);
      share.writeText(
        this.generateUrl(),
        1
      );
      WMSend("", share.getText());
    },
    generateUrl() {
      return `https://pedido.sirrusmoda.app/${this.$store.state.empresa.usuario_url}${(!this.$store.state.is_producao ? '?homologacao=true' : '')}`;
    },
  },
};
</script>

<style scoped>
.btn {
  width: 100%;
}
.btn-insta {
  background: #833ab4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #fcb045,
    #fd1d1d,
    #833ab4
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #fcb045,
    #fd1d1d,
    #833ab4
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.altura {
  height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/app/components/ShareComponent.vue